export const SUCCEED_SSO_URL = '/sso/auth/succeeded'
export const FAILED_SSO_URL = '/sso/auth/failed'

export default {
  SUCCEED_SSO_URL,
  FAILED_SSO_URL
}
